export default __webpack_public_path__ + "assets/brivia.c85198ee.webp";